import { FeatureFlagType } from "newui/features/Auth/types/FeatureFlag.type";

export const hasAFeatureFlag = (
	userFlags: FeatureFlagType[],
	featureFlag: FeatureFlagType
) => {
	if (!userFlags || userFlags.length === 0) {
		return false;
	}

	return userFlags.some((flag) => flag === featureFlag);
};
